import moment from 'moment-timezone'
import { IFullStop } from 'types'
import { FORMATS } from 'constants/datetime'
import { IAccessorial, IDetention, IDetentionShipment } from './types'

export interface IUpdateAccessorialsProps {
  shipment?: Partial<IDetentionShipment>
  accessorials?: IAccessorial[]
  detention: IDetention
  selectedStop?: IFullStop
  calculatedAmount: number
}

export const updateShipmentAccessorials = ({
  shipment,
  accessorials = [],
  detention,
  selectedStop,
  calculatedAmount,
}: IUpdateAccessorialsProps) => {
  const detentionUpdates = selectedStop?.status?.timezone
    ? {
        startAt: moment
          .tz(detention.startDateTime, FORMATS.datetimeInputFormat, selectedStop?.status?.timezone)
          .toISOString(),
        endAt: moment
          .tz(detention.endDateTime, FORMATS.datetimeInputFormat, selectedStop?.status?.timezone)
          .toISOString(),
        amount: String(calculatedAmount),
        additionalInfo: {
          ...detention?.additionalInfo,
          startDateTime: detention.startDateTime || '',
          endDateTime: detention.endDateTime || '',
        },
      }
    : {}

  const accessorialsUpdate = [{ ...detention, ...detentionUpdates }]
  const shipmentUpdates = { ...shipment, accessorials: [...accessorials, ...accessorialsUpdate] }
  if (shipmentUpdates?.customerCharges) shipmentUpdates.customerCharges.readyToInvoiceAt = undefined
  return shipmentUpdates
}
